import { StandardMemberAttributesDto } from '@act/shared/data-transfer-objects';

export function areAttributesEmpty(
  attributes: Partial<StandardMemberAttributesDto>,
  namedAttributes: string[]
): boolean {
  if (!attributes) return true;

  const reducedAttributes = namedAttributes.reduce((acc, key) => {
    return { ...acc, [key]: attributes[key] };
  }, {});

  return Object.values(reducedAttributes)?.every(v => !v);
}
